import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';

export class HTMLCreationUtils {
	public static createBackground(
		elementId: string,
		backgroundColor: string = 'rgba(0,0,0,1)',
		target: HTMLElement = document.body,
	): HTMLElement {
		const background = document.createElement('div');

		background.style.position = 'absolute';
		background.style.width = '100%';
		background.style.height = '100%';
		background.style.backgroundColor = backgroundColor;
		background.style.left = '0px';
		background.style.top = '0px';

		background.id = elementId;

		target.appendChild(background);

		return background;
	}

	public static createOverlayImage(
		textureName: string,
		target: HTMLElement = document.body,
		resourceLoader: ResourcesLoader,
	): HTMLImageElement {
		const image: HTMLImageElement = document.createElement('img');

		image.src = resourceLoader.getTexture(textureName).baseTexture.imageUrl;

		image.style.position = 'absolute';
		image.style.left = '50%';
		image.style.webkitTransform = 'translateX(-50%) translateY(-50%)';
		image.style.transform = 'translateX(-50%) translateY(-50%)';
		image.style.top = '50%';

		document.body.appendChild(image);

		return image;
	}

	public static getResourceImageUrl(textureName: string, resourceLoader: ResourcesLoader): string {
		return resourceLoader.getTexture(textureName).baseTexture.imageUrl;
	}

	public static getResourceUrl(resourceName: string, resourseLoader: ResourcesLoader): string {
		return resourseLoader.getPathForResource(resourceName);
	}

	/**
	 * For dynamically loading a script component or a vss component to the game.
	 *
	 * Example uses:
	 * loadjscssfile("myscript.js", "js") //dynamically load and add this .js file
	 * loadjscssfile("javascript.php", "js") //dynamically load "javascript.php" as a JavaScript
	 * file
	 * loadjscssfile("mystyle.css", "css") // dynamically load and add this .css file
	 * @memberof HTMLCreationUtils
	 */
	public static loadJsCssFile(fileName: string, fileType: string, target: any = null): void {
		let fileReference = null;

		if (fileType === 'js') {
			// if filename is a external JavaScript file
			fileReference = document.createElement('script');
			fileReference.setAttribute('type', 'text/javascript');
			fileReference.setAttribute('src', fileName);
		} else if (fileType === 'css') {
			// if filename is an external CSS file
			fileReference = document.createElement('link');
			fileReference.setAttribute('rel', 'stylesheet');
			fileReference.setAttribute('type', 'text/css');
			fileReference.setAttribute('href', fileName);
		}

		if (fileReference) {
			if (!target) {
				document.getElementsByTagName('head')[0].appendChild(fileReference);
			} else {
				target.appendChild(fileReference);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/html/HTMLCreationUtils.ts